import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { ToastProvider } from "./components/ui";
import "./index.css";
import { ErrorBoundary, installErrorReporting } from "./components/ErrorBoundary";
import { VersionWatcher } from "./components/VersionWatcher";

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);
installErrorReporting(convex);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConvexAuthProvider client={convex}>
      <ToastProvider>
        <ErrorBoundary>
          <RouterProvider router={router} />
          <VersionWatcher />
        </ErrorBoundary>
      </ToastProvider>
    </ConvexAuthProvider>
  </StrictMode>,
);
